<!-- 缺省页 -->
<template>
  <div style="width:100%;" class="p_flex p_justify_center">
    <div :style="{ width: width }" class="p_flex p_column p_align_items">
      <img style="width: 100%;" src="@/assets/images/no/nocontent.png" alt="" />
      <span :style="{ fontSize: font }" class="color_8F8F8F">{{$t('content.nocontent')}}</span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    width: {
      type: String,
      default: '250px'
    },
    font: {
      type: String,
      default: '18px'
    }
  },
  components: {},
  created() {},
  mounted() {},
  computed: {},
  methods: {}
};
</script>

<style scoped="scoped"></style>



// WEBPACK FOOTER //
// src/components/public-nocontent/public-nocontent.vue